module.exports = __webpack_public_path__ + "static/tampa-0e222945dffebc287a468fbe61fff55a.png";